module.exports = __webpack_public_path__ + "img/chofu_zerosmoke_on.454c7864.svg";